import { Resource } from 'types'
import { get } from './helpers'

export const getResourceById = async (resourceId: string): Promise<Resource> => {
  const response = await get<Resource>(`/resources/${resourceId}`)
  return response
}
